import { createFileRoute } from "@tanstack/react-router";
import { ListChecksIcon } from "lucide-react";
import { OnboardingManagement } from "@/components/dashboard/onboarding/onboarding-management";
import { onboardingOverviewQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/onboarding")({
  // A head start on the default view; the page renders its own skeleton.
  loader: ({ context }) => {
    warm(context.queryClient.ensureQueryData(onboardingOverviewQuery));
  },
  component: OnboardingPage,
});

function OnboardingPage() {
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-6xl space-y-6">
        <div className="space-y-1">
          <p className="flex items-center gap-1.5 font-medium text-[10px] text-muted-foreground uppercase tracking-[0.25em]">
            <ListChecksIcon className="size-3.5" />
            Onboarding
          </p>
          <h1 className="font-bold text-2xl tracking-tight">Onboarding checklist</h1>
          <p className="text-muted-foreground text-sm">
            Track every new hire's progress, knock out HR-side tasks, and keep your onboarding
            template up to date.
          </p>
        </div>

        <OnboardingManagement />
      </div>
    </main>
  );
}
